import React from "react";
import "./scss/resume.css";
import { SectionHeader } from "../../styledcomponents/SectionHeader/SectionHeader";
import ResumeCard from "../../styledcomponents/ResumeCard/index";

import "animate.css/animate.min.css";
import ScrollAnimation from "react-animate-on-scroll";

const Resume = (props) => {
  return (
    <div className="resume" id="resume">
      <div className="resume__container">
        <SectionHeader>Resume</SectionHeader>

        <div className="resume__content">
          <div className="resume__left">
            <ScrollAnimation
              animateIn="left_ref"
              animateOnce={true}
              duration={0.7}
            >
              <ResumeCard
                title="Bsc Computer Science"
                content="2015-2019 at Ahmadu Bello University (ABU)"
                iconname="graduate"
              />
            </ScrollAnimation>
          </div>

          <div className="resume__right">
            <ScrollAnimation
              animateIn="right_ref"
              animateOnce={true}
              duration={0.7}
            >
              <ResumeCard
                title="NIIT Android App Development cert."
                content="2017-2018 at NIIT"
                iconname="graduate"
              />
            </ScrollAnimation>
          </div>

          <ScrollAnimation
            animateIn="left_ref"
            animateOnce={true}
            duration={0.7}
          >
            <ResumeCard
              title="Freelance Android App Developer"
              content="2018-present at home ;)"
              iconname="suitcase"
            />
          </ScrollAnimation>

          <ScrollAnimation
            animateIn="right_ref"
            animateOnce={true}
            duration={0.7}
          >
            <ResumeCard
              title="Frontend Developer."
              content="2020-2021 at STETiS"
              iconname="suitcase"
            />
          </ScrollAnimation>
          <ScrollAnimation
            animateIn="left_ref"
            animateOnce={true}
            duration={0.7}
          >
            <ResumeCard
              title="Frontend Developer."
              content="2021-present at Comsoft Ltd"
              iconname="suitcase"
            />
          </ScrollAnimation>
        </div>
      </div>
    </div>
  );
};

export default Resume;
